module.exports = __webpack_public_path__ + "img/文字_D级赛事@2x.1fe54690.png";